import Vue from 'vue'
import VueRouter from 'vue-router'
import StartPage from '../views/StartPage.vue'
import EducationPage from '@/views/Education/EducationPage.vue'
import MainPage from '@/views/MainPage/MainPage.vue'
import GoalPanel from '@/views/GoalPage/GoalPage.vue'
import ProfilePage from '@/views/ProfilePage/ProfilePage.vue'
import GpsPage from '@/views/GpsPage.vue'
import TaskList from '@/views/MainPage/TaskList.vue'
import AllGoals from '@/views/GoalPage/AllGoals.vue'
import AddGoal from '@/views/GoalPage/AddGoal/AddGoal.vue'
import UserAuthorization from '@/views/autorization/UserAuthorization.vue'
import PrivacyPolicy from '@/views/PrivacyPolicy.vue'
import RememberPassword from '@/views/autorization/RememberPassword.vue'
import UserRegistration from '@/views/autorization/UserRegistration.vue'
import KiddLinks from '@/views/KiddLinks.vue'
import KiddieSupport from '@/views/KiddieSupport.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/auth',
    name: 'auth',
    component: UserAuthorization
  },
  {
    props: true,
    path: '/recoverpass/:phoneApp?',
    name: 'recoverpass',
    component: RememberPassword
  },
  {
    props: true,
    path: '/registration/:devId?',
    name: 'registration',
    component: UserRegistration
  },
  {
    path: '/support',
    name: 'support',
    component: KiddieSupport
  },
  {
    path: '/start',
    name: 'start',
    component: StartPage
  },
  {
    path: '/privacypolicy',
    name: 'privacypolicy',
    component: PrivacyPolicy
  },
  {
    path: '/educationpage',
    name: 'EducationPage',
    component: EducationPage
  },
  {
    path: '/home',
    name: 'MainPage',
    component: MainPage
  },
  {
    path: '/goalPage',
    name: 'GoalPage',
    component: GoalPanel
  },
  {
    path: '/profilePage',
    name: 'ProfilePage',
    component: ProfilePage
  },
  {
    path: '/GpsPage',
    name: 'GpsPage',
    component: GpsPage
  },
  {
    path: '/allTasks',
    name: 'TaskList',
    component: TaskList
  },
  {
    path: '/allGoals/:categoryGoals/:goalUuid?',
    props: true,
    name: 'AllGoals',
    component: AllGoals
  },
  {
    path: '/addGoal/:goalUuid?',
    props: true,
    name: 'AddGoal',
    component: AddGoal
  },
  {
    path: '/rewards/:type/:rest(.*)',
    props: true,
    name: 'KiddLinks',
    component: KiddLinks
  },
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  base: process.env.BASE_URL,
  routes
})

export default router
